export enum SubdomainTypes {
  EnrollAndPay,
  EagleProcessing,
}
